export default {
    props: {
        navigatorCategoryAxisAutoBaseUnitStepsSeconds: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.seconds'
        }, 
        navigatorCategoryAxisAutoBaseUnitStepsMinutes: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.minutes'
        }, 
        navigatorCategoryAxisAutoBaseUnitStepsHours: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.hours'
        }, 
        navigatorCategoryAxisAutoBaseUnitStepsDays: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.days'
        }, 
        navigatorCategoryAxisAutoBaseUnitStepsWeeks: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.weeks'
        }, 
        navigatorCategoryAxisAutoBaseUnitStepsMonths: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.months'
        }, 
        navigatorCategoryAxisAutoBaseUnitStepsYears: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.autoBaseUnitSteps.years'
        }, 
        navigatorCategoryAxisAxisCrossingValue: {
            type: [Object, Date, Array],
            default: undefined,
            kComposite: 'navigator.categoryAxis.axisCrossingValue'
        }, 
        navigatorCategoryAxisBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.background'
        }, 
        navigatorCategoryAxisBaseUnit: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.baseUnit'
        }, 
        navigatorCategoryAxisBaseUnitStep: {
            type: Object,
            default: undefined,
            kComposite: 'navigator.categoryAxis.baseUnitStep'
        }, 
        navigatorCategoryAxisCategories: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.categories'
        }, 
        navigatorCategoryAxisColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.color'
        }, 
        navigatorCategoryAxisCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.color'
        }, 
        navigatorCategoryAxisCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.opacity'
        }, 
        navigatorCategoryAxisCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.background'
        }, 
        navigatorCategoryAxisCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.border.color'
        }, 
        navigatorCategoryAxisCrosshairTooltipBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.border.dashType'
        }, 
        navigatorCategoryAxisCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.border.width'
        }, 
        navigatorCategoryAxisCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.color'
        }, 
        navigatorCategoryAxisCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.font'
        }, 
        navigatorCategoryAxisCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.format'
        }, 
        navigatorCategoryAxisCrosshairTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding'
        }, 
        navigatorCategoryAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding.bottom'
        }, 
        navigatorCategoryAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding.left'
        }, 
        navigatorCategoryAxisCrosshairTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding.right'
        }, 
        navigatorCategoryAxisCrosshairTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.padding.top'
        }, 
        navigatorCategoryAxisCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.template'
        }, 
        navigatorCategoryAxisCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.tooltip.visible'
        }, 
        navigatorCategoryAxisCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.visible'
        }, 
        navigatorCategoryAxisCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.crosshair.width'
        }, 
        navigatorCategoryAxisField: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.field'
        }, 
        navigatorCategoryAxisJustified: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.justified'
        }, 
        navigatorCategoryAxisLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.background'
        }, 
        navigatorCategoryAxisLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.border.color'
        }, 
        navigatorCategoryAxisLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.border.dashType'
        }, 
        navigatorCategoryAxisLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.border.width'
        }, 
        navigatorCategoryAxisLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.color'
        }, 
        navigatorCategoryAxisLabelsCulture: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.culture'
        }, 
        navigatorCategoryAxisLabelsDateFormatsDays: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.days'
        }, 
        navigatorCategoryAxisLabelsDateFormatsHours: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.hours'
        }, 
        navigatorCategoryAxisLabelsDateFormatsMonths: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.months'
        }, 
        navigatorCategoryAxisLabelsDateFormatsWeeks: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.weeks'
        }, 
        navigatorCategoryAxisLabelsDateFormatsYears: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.dateFormats.years'
        }, 
        navigatorCategoryAxisLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.font'
        }, 
        navigatorCategoryAxisLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.format'
        }, 
        navigatorCategoryAxisLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.margin'
        }, 
        navigatorCategoryAxisLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.margin.bottom'
        }, 
        navigatorCategoryAxisLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.margin.left'
        }, 
        navigatorCategoryAxisLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.margin.right'
        }, 
        navigatorCategoryAxisLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.margin.top'
        }, 
        navigatorCategoryAxisLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.mirror'
        }, 
        navigatorCategoryAxisLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.padding'
        }, 
        navigatorCategoryAxisLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.padding.bottom'
        }, 
        navigatorCategoryAxisLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.padding.left'
        }, 
        navigatorCategoryAxisLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.padding.right'
        }, 
        navigatorCategoryAxisLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.padding.top'
        }, 
        navigatorCategoryAxisLabelsRotation: {
            type: [Number, String],
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.rotation'
        }, 
        navigatorCategoryAxisLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.skip'
        }, 
        navigatorCategoryAxisLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.step'
        }, 
        navigatorCategoryAxisLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.template'
        }, 
        navigatorCategoryAxisLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.labels.visible'
        }, 
        navigatorCategoryAxisLineColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.line.color'
        }, 
        navigatorCategoryAxisLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.line.dashType'
        }, 
        navigatorCategoryAxisLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.line.visible'
        }, 
        navigatorCategoryAxisLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.line.width'
        }, 
        navigatorCategoryAxisMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorGridLines.color'
        }, 
        navigatorCategoryAxisMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorGridLines.dashType'
        }, 
        navigatorCategoryAxisMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorGridLines.visible'
        }, 
        navigatorCategoryAxisMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorGridLines.width'
        }, 
        navigatorCategoryAxisMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorGridLines.step'
        }, 
        navigatorCategoryAxisMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorGridLines.skip'
        }, 
        navigatorCategoryAxisMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorTicks.color'
        }, 
        navigatorCategoryAxisMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorTicks.size'
        }, 
        navigatorCategoryAxisMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorTicks.visible'
        }, 
        navigatorCategoryAxisMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorTicks.width'
        }, 
        navigatorCategoryAxisMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorTicks.step'
        }, 
        navigatorCategoryAxisMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.majorTicks.skip'
        }, 
        navigatorCategoryAxisMax: {
            type: Object,
            default: undefined,
            kComposite: 'navigator.categoryAxis.max'
        }, 
        navigatorCategoryAxisMaxDateGroups: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.maxDateGroups'
        }, 
        navigatorCategoryAxisMin: {
            type: Object,
            default: undefined,
            kComposite: 'navigator.categoryAxis.min'
        }, 
        navigatorCategoryAxisMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorGridLines.color'
        }, 
        navigatorCategoryAxisMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorGridLines.dashType'
        }, 
        navigatorCategoryAxisMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorGridLines.visible'
        }, 
        navigatorCategoryAxisMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorGridLines.width'
        }, 
        navigatorCategoryAxisMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorGridLines.step'
        }, 
        navigatorCategoryAxisMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorGridLines.skip'
        }, 
        navigatorCategoryAxisMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorTicks.color'
        }, 
        navigatorCategoryAxisMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorTicks.size'
        }, 
        navigatorCategoryAxisMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorTicks.visible'
        }, 
        navigatorCategoryAxisMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorTicks.width'
        }, 
        navigatorCategoryAxisMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorTicks.step'
        }, 
        navigatorCategoryAxisMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.minorTicks.skip'
        }, 
        navigatorCategoryAxisPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.plotBands'
        },         navigatorCategoryAxisReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.reverse'
        }, 
        navigatorCategoryAxisRoundToBaseUnit: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.roundToBaseUnit'
        }, 
        navigatorCategoryAxisTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.background'
        }, 
        navigatorCategoryAxisTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.border.color'
        }, 
        navigatorCategoryAxisTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.border.dashType'
        }, 
        navigatorCategoryAxisTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.border.width'
        }, 
        navigatorCategoryAxisTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.color'
        }, 
        navigatorCategoryAxisTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.font'
        }, 
        navigatorCategoryAxisTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.margin'
        }, 
        navigatorCategoryAxisTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.margin.bottom'
        }, 
        navigatorCategoryAxisTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.margin.left'
        }, 
        navigatorCategoryAxisTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.margin.right'
        }, 
        navigatorCategoryAxisTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.margin.top'
        }, 
        navigatorCategoryAxisTitlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.padding'
        }, 
        navigatorCategoryAxisTitlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.padding.bottom'
        }, 
        navigatorCategoryAxisTitlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.padding.left'
        }, 
        navigatorCategoryAxisTitlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.padding.right'
        }, 
        navigatorCategoryAxisTitlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.padding.top'
        }, 
        navigatorCategoryAxisTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.position'
        }, 
        navigatorCategoryAxisTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.rotation'
        }, 
        navigatorCategoryAxisTitleText: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.text'
        }, 
        navigatorCategoryAxisTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.title.visible'
        }, 
        navigatorCategoryAxisVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.visible'
        }, 
        navigatorCategoryAxisWeekStartDay: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.weekStartDay'
        }, 
        navigatorCategoryAxisNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.position'
        }, 
        navigatorCategoryAxisNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.icon.background'
        }, 
        navigatorCategoryAxisNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.icon.border.color'
        }, 
        navigatorCategoryAxisNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.icon.border.width'
        }, 
        navigatorCategoryAxisNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.icon.size'
        }, 
        navigatorCategoryAxisNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.icon.type'
        }, 
        navigatorCategoryAxisNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.icon.visible'
        }, 
        navigatorCategoryAxisNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.background'
        }, 
        navigatorCategoryAxisNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.border.color'
        }, 
        navigatorCategoryAxisNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.border.dashType'
        }, 
        navigatorCategoryAxisNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.border.width'
        }, 
        navigatorCategoryAxisNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.color'
        }, 
        navigatorCategoryAxisNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.font'
        }, 
        navigatorCategoryAxisNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.template'
        }, 
        navigatorCategoryAxisNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.visible'
        }, 
        navigatorCategoryAxisNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.rotation'
        }, 
        navigatorCategoryAxisNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.format'
        }, 
        navigatorCategoryAxisNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.label.position'
        }, 
        navigatorCategoryAxisNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.line.width'
        }, 
        navigatorCategoryAxisNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.line.color'
        }, 
        navigatorCategoryAxisNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.line.length'
        }, 
        navigatorCategoryAxisNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'navigator.categoryAxis.notes.data'
        },
        navigatorDataSource: {
            type: Object,
            default: undefined,
            kComposite: 'navigator.dataSource'
        }, 
        navigatorAutoBind: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.autoBind'
        }, 
        navigatorDateField: {
            type: String,
            default: undefined,
            kComposite: 'navigator.dateField'
        }, 
        navigatorPaneBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.background'
        }, 
        navigatorPaneBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.border.color'
        }, 
        navigatorPaneBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.border.dashType'
        }, 
        navigatorPaneBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.border.width'
        }, 
        navigatorPaneHeight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.height'
        }, 
        navigatorPaneMargin: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.margin'
        }, 
        navigatorPaneMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.margin.bottom'
        }, 
        navigatorPaneMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.margin.left'
        }, 
        navigatorPaneMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.margin.right'
        }, 
        navigatorPaneMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.margin.top'
        }, 
        navigatorPaneName: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.name'
        }, 
        navigatorPanePadding: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.padding'
        }, 
        navigatorPanePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.padding.bottom'
        }, 
        navigatorPanePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.padding.left'
        }, 
        navigatorPanePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.padding.right'
        }, 
        navigatorPanePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.padding.top'
        }, 
        navigatorPaneTitle: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title'
        }, 
        navigatorPaneTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.background'
        }, 
        navigatorPaneTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.border.color'
        }, 
        navigatorPaneTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.border.dashType'
        }, 
        navigatorPaneTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.title.border.width'
        }, 
        navigatorPaneTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.color'
        }, 
        navigatorPaneTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.font'
        }, 
        navigatorPaneTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.title.margin'
        }, 
        navigatorPaneTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.title.margin.bottom'
        }, 
        navigatorPaneTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.title.margin.left'
        }, 
        navigatorPaneTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.title.margin.right'
        }, 
        navigatorPaneTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'navigator.pane.title.margin.top'
        }, 
        navigatorPaneTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.position'
        }, 
        navigatorPaneTitleText: {
            type: String,
            default: undefined,
            kComposite: 'navigator.pane.title.text'
        }, 
        navigatorPaneTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.pane.title.visible'
        }, 
        navigatorVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.visible'
        }, 
        navigatorSeries: {
            type: [Array, Object],
            default: undefined,
            kComposite: 'navigator.series'
        },
        navigatorSelectFrom: {
            type: [Date, String],
            default: undefined,
            kComposite: 'navigator.select.from'
        }, 
        navigatorSelectMousewheel: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.select.mousewheel'
        }, 
        navigatorSelectMousewheelReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.select.mousewheel.reverse'
        }, 
        navigatorSelectMousewheelZoom: {
            type: String,
            default: undefined,
            kComposite: 'navigator.select.mousewheel.zoom'
        }, 
        navigatorSelectTo: {
            type: [Date, String],
            default: undefined,
            kComposite: 'navigator.select.to'
        }, 
        navigatorHintVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'navigator.hint.visible'
        }, 
        navigatorHintTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'navigator.hint.template'
        }, 
        navigatorHintFormat: {
            type: String,
            default: undefined,
            kComposite: 'navigator.hint.format'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoStockChart/Navigator.js